// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-form-field{
    width: 100%;
}
form small.error{
    position: relative;
    top: -24px;
}
a{
    color: #DA512D;
    text-decoration: none;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNhZmFyYXR0aS10cmF2ZWwtcGxhbi1hZGQuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLFdBQVc7QUFDZjtBQUNBO0lBQ0ksa0JBQWtCO0lBQ2xCLFVBQVU7QUFDZDtBQUNBO0lBQ0ksY0FBYztJQUNkLHFCQUFxQjtBQUN6QiIsImZpbGUiOiJzYWZhcmF0dGktdHJhdmVsLXBsYW4tYWRkLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIubWF0LWZvcm0tZmllbGR7XG4gICAgd2lkdGg6IDEwMCU7XG59XG5mb3JtIHNtYWxsLmVycm9ye1xuICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICB0b3A6IC0yNHB4O1xufVxuYXtcbiAgICBjb2xvcjogI0RBNTEyRDtcbiAgICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG59Il19 */`, "",{"version":3,"sources":["webpack://./src/app/safaratti-travel-plan-add/safaratti-travel-plan-add.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA,glBAAglB","sourcesContent":[".mat-form-field{\n    width: 100%;\n}\nform small.error{\n    position: relative;\n    top: -24px;\n}\na{\n    color: #DA512D;\n    text-decoration: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
